/*eslint-disable */

import 'cropperjs/dist/cropper.css';

import VueCropper from 'vue-cropperjs';
import {
  bus
} from '@/main';
import toast from '@/services/toast';

var $ = window.jQuery = require('jquery');
export default {
  name: 'update-group-info',
  components: {
    VueCropper
  },
  props: ['updateGroupIconID'],
  data () {
    return {
      submitted:false,
      uploadAttachmentName:'',
      file:null,
      selectedFile:null,
      imgSrc:'',
      cropImg: '',
    }
  },
  computed: {

  },
  mounted () {
    document.body.classList.add('body_right_scroll_remove');
    this.getGroupInfoByIdMethod(false);
  },
  methods: {
    getGroupInfoByIdMethod(evt){
      this.$store.dispatch('getGroupChatDetailsByIdFun', { id: this.updateGroupIconID }).then((res)=>{
        this.selectedFile = res.data.data.group_image;
        if(evt){
          bus.$emit('updateGroupInfoDataBus', res.data.data);
        }
      })
    },
    handleAttachmentUpload(e) {
      const file = e.target.files[0];
      this.uploadAttachmentName = file.name;
      if (file.type.indexOf('image/') === -1) {
        alert('Please select an image file');
        return;
      }
      if (typeof FileReader === 'function') {
        const reader = new FileReader();
        reader.onload = (event) => {
          this.imgSrc = event.target.result;
        };
        reader.readAsDataURL(file);
      } else {
        alert('Sorry, FileReader API not supported');
      }
    },
    cropImage(){
      this.cropImg = this.$refs.cropper.getCroppedCanvas().toDataURL();
      let cropperImg = this.cropImg;
      cropperImg = cropperImg.replace(/^data:image\/(png|jpg);base64,/, "")
      this.submitted =  true
      let data = {
        "group_image": cropperImg,
        "filename": this.uploadAttachmentName,
      }
      var formData = new FormData();
      formData.append('group_image', cropperImg);
      this.$store.dispatch('updateGroupChatDetailsFun', {data:{data:data,id:this.updateGroupIconID}}).then((res) => {
        toast.success(res.data.msg);
        this.getGroupInfoByIdMethod(true);
        this.cancelCropMethod();
        this.submitted =  false;
      }).catch((err)=>{
        this.submitted =  false;
        toast.error(err.data.msg);
      })
    },
    cancelCropMethod(){
      setTimeout(()=>{
        this.imgSrc = '';
        this.uploadAttachmentName = '';
        this.$refs.cropper.reset();
      },10)
    },
    updateGroupPopupDisabledFun(){
     document.body.classList.remove('body_right_scroll_remove');
      bus.$emit('updateGroupIconPopupStateBus', false);
    }
  },
  watch:{
  }
}